<template>
  <div class="LanguageSelector__Wrapper">
    <div
      class="LanguageSelector__ClosingWindow"
      @click.prevent="selectLanguage = !selectLanguage"
      v-if="selectLanguage"
    />
    <div class="LanguageSelector__Buttons">
      <div
        class="LanguageSelector__Container"
        @click="selectLanguage = !selectLanguage"
        v-if="!selectLanguage"
      >
        <p class="LanguageSelector__Text">
          {{ GetSelectedLanguageName() }}
        </p>
      </div>
      <div
        class="LanguageSelector__List"
        v-if="selectLanguage"
      >
        <div
          class="LanguageSelector__Container"
          @click="selectLanguage = !selectLanguage"
        >
          <div class="LanguageSelector__CloseButton" />
        </div>
        <div
          class="LanguageSelector__ContainerBis"
          v-for="lang in langs"
          :key="lang.iso"
          @click="SelectLanguage(lang.iso)"
        >
          <p class="LanguageSelector__Text">
            {{ lang.name }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      selectLanguage: false
    }
  },
  computed: {
    ...mapGetters(['langs', 'selectedLang'])
  },
  methods: {
    GetSelectedLanguageName () {
      for (let i = 0; i < this.langs.length; i++) {
        if (this.langs[i].iso === this.selectedLang) {
          return this.langs[i].name
        }
      }
      return ''
    },
    SelectLanguage (iso) {
      this.selectLanguage = false
      this.$store.dispatch('SetLang', iso)
    }
  }
}
</script>

<style scoped>
.LanguageSelector__Buttons {
  z-index: 10;
}

.LanguageSelector__Wrapper{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  pointer-events: none;
  filter: drop-shadow(0 1mm 1mm rgb(0, 0, 0, 0.3));
}

.LanguageSelector__ClosingWindow {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: auto;
}

@media screen and (max-width: 1300px) {
.LanguageSelector__Container {
  margin-left: 55px;
  margin-top: 30px;
  width: 42px;
  height: 42px;
  background: white;
  display: flex;
  justify-content: center;
  border-radius: 100%;
  margin-bottom: 1em;
  pointer-events: auto;
}
.LanguageSelector__ContainerBis {
  margin-left: 55px;
  margin-top: 10px;
  width: 42px;
  height: 42px;
  background: white;
  display: flex;
  justify-content: center;
  border-radius: 100%;
  margin-bottom: 1em;
  pointer-events: auto;
}
.LanguageSelector__Text {
  margin: auto;
  align-content: center;
  font-size: 0.8em;
  font-weight: 300;
  padding-top: 0px;
}
}

@media screen and (min-width: 1300px) {
.LanguageSelector__Container {
  margin-left: 55px;
  margin-top: 55px;
  width: 55px;
  height: 55px;
  background: white;
  display: flex;
  justify-content: center;
  border-radius: 100%;
  margin-bottom: 1em;
  pointer-events: auto;
}
.LanguageSelector__ContainerBis {
  margin-left: 55px;
  margin-top: 15px;
  width: 55px;
  height: 55px;
  background: white;
  display: flex;
  justify-content: center;
  border-radius: 100%;
  margin-bottom: 1em;
  pointer-events: auto;
}
.LanguageSelector__Text {
  margin: auto;
  align-content: center;
  font-size: 1em;
  font-weight: 300;
    padding-top: 0px;
}
}

.LanguageSelector__List{
  pointer-events: auto;
}

.LanguageSelector__CloseButton {
  width: 50%;
  height: 50%;
  margin: auto;
  background: black;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  mask-image: url('../../assets/icons/close.svg');
}
</style>
